export type FilterPair = {
  key: string,
  value: string
}

const buildFilterPair = (key: string = '', value: string = ''): FilterPair => {
  return {
    key,
    value
  }
}

export {
  buildFilterPair
}



// WEBPACK FOOTER //
// ./src/types/filter-pair.js